import { INSERT_MODE } from 'src/constants';
import { setGlobalState } from 'src/store/helpers';

export const isVisualMode = (mode: string): boolean => {
  if (mode === INSERT_MODE) {
    return false;
  }
  return true;
};

export const setGlobalStateMode = (mode: string) => () => {
  return setGlobalState({ mode });
};
